import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import SystemSettingsContainer from './components/SystemSettings/SystemSettingsContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';

const SystemSettingsManagement = () => (
  <PageContainer pageName="system-settings">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_SYSTEM_SETTINGS}>
      <SystemSettingsContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default SystemSettingsManagement;
